module.exports = __webpack_public_path__ + "img/hmp-logo-color.c1b1a5f5.png";